<template lang="pug">
  LeadsList(:leads="leads" create=false title="All User Leads")
</template>

<script>
import { mapGetters } from "vuex";
import dashboardService from '../../service.js'
import LeadsList from '../../../Leads/components/LeadsList'

export default {
  data() {
    return {
      leads: []
    }
  },
  components: {
    LeadsList
  },
  mounted() {
    this.allUserDueLeads()
  },
  methods: {
    allUserDueLeads() {
      return dashboardService
      .allUserDueLeads()
      .then((response) => {
        console.log('response', response)
        this.leads = response.data
      })
    },
  }
}
</script>

<style scoped>
</style>